import { GLOBAL_FIELD_NAMES, STRENGTH_WEAKNESSES_NAMES } from '../../Sections/Global/form';
import { ol, ul } from '../helpers';

const COMPANY_STRENGTHS_INSTRUCTIONS = {
  [STRENGTH_WEAKNESSES_NAMES.TITLE]: {
    name: 'Stärken',
    instruction:
      'Identifizieren Sie Kernkompetenzen und Ressourcen, die Ihrem Unternehmen einen Marktvorteil verschaffen. Heben Sie spezialisierte Fähigkeiten, einzigartige Kompetenzen und Markenreputation hervor.',
    exampleOne: ul([
      'Spezialisierte Expertise in der Konstruktion und Herstellung von Ketten­traktoren für schwere oder nasse Böden.',
      'Einzigartige patentierte gummibeschichtete Endlosketten-Technologie mit überlegener Traktion und Auftrieb.',
      'Starkes Team aus erfahrenen Ingenieuren, Agrarspezialisten und Branchenexperten.',
    ]),
    exampleTwo: ul([
      'Ein sicheres Zahlungssystem stellt sicher, dass finanzielle Transaktionen innerhalb der Plattform sicher abgewickelt werden.',
      'Ein strenger Prüfprozess für Übersetzer gewährleistet hochwertige und zuverlässige Dienstleistungen.',
      'Engagiertes Team mit Expertise in Programmierung, Sprachdienstleistungen und Kundensupport.',
    ]),
  },
};

const COMPANY_WEAKNESSES_INSTRUCTIONS = {
  [STRENGTH_WEAKNESSES_NAMES.TITLE]: {
    name: 'Schwächen',
    instruction:
      'Identifizieren Sie interne Einschränkungen und Herausforderungen des Unternehmens. Beschreiben Sie transparent Bereiche mit Verbesserungsbedarf: Prozesse, Ressourcen, Kompetenzen. Gehen Sie auf Lücken im Vergleich zu Branchenstandards, operative Ineffizienzen und deren Auswirkungen auf Leistung und Wettbewerbsfähigkeit ein.',
    exampleOne: ul([
      'Abhängigkeit von einer einzigen patentierten Technologie zur Differenzierung der Traktoren begrenzt die Produktdiversifizierung.',
      'Herausforderungen bei der Skalierung der Produktion zur Deckung steigender Nachfrage aufgrund begrenzter Fertigungskapazitäten.',
      'Fehlende geografische Diversifizierung mit starker Abhängigkeit von einem bestimmten Markt oder einer Region für den Vertrieb.',
    ]),
    exampleTwo: ul([
      'Begrenzte Markenbekanntheit und Marktpräsenz im Vergleich zu etablierten Wettbewerbern.',
      'Abhängigkeit von Drittanbieter-Technologien für bestimmte Plattformfunktionen.',
      'Abhängigkeit von einem relativ kleinen Team kann in Nachfragespitzen zu Ressourcenengpässen führen.',
    ]),
  },
};

export const GLOBAL_INSTRUCTIONS = {
  [GLOBAL_FIELD_NAMES.COMPANY_NAME]: {
    name: 'Unternehmensname',
    instruction:
      'Geben Sie den vorgesehenen vollständigen und offiziellen Namen Ihres Unternehmens an. Ist das Unternehmen noch nicht registriert, sollte der Name Ihre Markenvision und die geplante offizielle Registrierung widerspiegeln.',
    exampleOne: 'Agrotech',
    exampleTwo: 'LanguageLab',
  },
  [GLOBAL_FIELD_NAMES.REGISTRATION_DATE]: {
    name: 'Registrierungsdatum',
    instruction:
      'Geben Sie das genaue Datum der offiziellen Unternehmensregistrierung an, inklusive Jahr, Monat und Tag.',
    exampleOne: '8.16.2001',
    exampleTwo: '3.15.2008',
  },
  [GLOBAL_FIELD_NAMES.ADDRESS]: {
    name: 'Registrierungsadresse',
    instruction:
      'Geben Sie Stadt und Land an, in denen Ihr Unternehmen offiziell registriert ist. Stellen Sie genaue Angaben bereit, um rechtliche Anfragen oder Geschäfts­transaktionen zu erleichtern.',
    exampleOne: '89 N Smeeth St, Charlotte, CA 28202, US',
    exampleTwo: '100 N Tailor St, Charlotte, NC 28202, US',
  },
  [GLOBAL_FIELD_NAMES.COMPANY_BRIEF_DESCRIPTION]: {
    name: 'Kurzbeschreibung des Unternehmens',
    instruction:
      'Formulieren Sie eine prägnante Unternehmensübersicht. Welche einzigartigen Aspekte differenzieren Ihr Unternehmen am Markt? Beschreiben Sie die wichtigsten Produkte oder Dienstleistungen und betonen Sie Innovation oder Wettbewerbsvorteile. Nennen Sie bedeutende Meilensteine und strategische Partnerschaften.',
    exampleOne:
      'Agrotech stellt leistungsstarke Ketten­traktoren für schwere oder nasse Böden her. Das einzigartige Endlosketten-Design bietet überlegene Traktion und Auftrieb und minimiert dank patentierter Gummibeschichtung Bodenbelastung und -schäden. Mit Fokus auf Leistung und Umweltverantwortung liefert das Unternehmen moderne Lösungen für aktuelle Herausforderungen in der Landwirtschaft.',
    exampleTwo:
      'LanguageLab ist eine Sprachdienstleistungs-Plattform, die globale Kommunikation in über 100 Sprachen optimiert. Das Unternehmen unterstützt Kunden und Übersetzer dabei, ihr Kommunikationserlebnis zu verbessern, indem es nahtlose Interaktionsprozesse ermöglicht.',
  },
  [GLOBAL_FIELD_NAMES.NUMBER_OF_EMPLOYEES]: {
    name: 'Anzahl der Mitarbeitenden',
    instruction:
      'Geben Sie die aktuelle Anzahl der Mitarbeitenden Ihres Unternehmens an, inklusive Vollzeit-, Teilzeit- und Vertragskräfte.',
    exampleOne: '',
    exampleTwo: '',
  },
  [GLOBAL_FIELD_NAMES.ANNUAL_INCOME]: {
    name: 'Vergangenes Jahreseinkommen',
    instruction:
      'Berechnen und nennen Sie das durchschnittliche Jahreseinkommen, indem Sie Ihr gesamtes Einkommen der letzten drei Jahre addieren und durch drei teilen. Diese Kennzahl sollte korrekt sein und Ihre finanzielle Entwicklung über diesen Zeitraum konsistent widerspiegeln.',
    exampleOne: '',
    exampleTwo: '',
  },
  [GLOBAL_FIELD_NAMES.PROJECT_BRIEF_DESCRIPTION]: {
    name: 'Projektbeschreibung',
    instruction:
      'Beschreiben Sie kurz das Wesen des Investitionsprojekts – z. B. neue Betriebsstätte, Modernisierung oder Markterweiterung. Stellen Sie das Zielunternehmen vor, inklusive Branche, Marktpräsenz, Kernprodukte, finanzieller Lage und Stärken, und erläutern Sie die Gründe für die geplante Investition oder Übernahme.',
    exampleOne:
      'Der Businessplan fokussiert auf spezialisierte Ketten­traktoren mit patentierter Endlosketten-Technologie, um Produktivitätsprobleme auf schweren Böden zu lösen. Dank Innovation bieten die Traktoren längere Lebenszyklen, senken Kosten und steigern langfristig die Profitabilität für Landwirte.',
    exampleTwo:
      'Das Unternehmen begegnet der Dezentralisierung des Übersetzungsmarktes mit einer zentralen Plattform, strengen Prüfprozessen, sicheren Zahlungen und KI-gestützter Technologie. Unsere Strategie nutzt Technologie zur Prozessoptimierung und stärkt Kommunikation, Effizienz und Vertrauen aller Stakeholder.',
  },
  [GLOBAL_FIELD_NAMES.MAIN_PRODUCTS_OR_SERVICES]: {
    name: 'Hauptprodukte/-dienstleistungen',
    instruction:
      'Stellen Sie eine strukturierte Liste Ihrer Produkte oder Dienstleistungen zusammen. Gruppieren Sie sie in Kategorien oder heben Sie Leitprodukte hervor, die Ihr Geschäft definieren. Betonen Sie wesentliche Merkmale oder Qualitäten, die Ihre Angebote von Wettbewerbern abheben, z. B. Innovation, Qualität oder einzigartige Funktionen.',
    exampleOne:
      'Das Unternehmen ist auf die Herstellung leistungsstarker Ketten­traktoren für schwere oder nasse Böden spezialisiert. Zu den Produkten gehören:' +
      ol(['Ketten­traktoren', 'Landwirtschaftliche Geräte', 'Umweltlösungen']),
    exampleTwo:
      'Das Unternehmen bietet eine Reihe von Produkten und Dienstleistungen zur Optimierung globaler Kommunikation und Interaktionsprozesse. Das Angebot umfasst:' +
      ol([
        'Übersetzungsdienstleistungen',
        'KI-gestützte Übersetzungstools',
        'Lösungen zur Kommunikationsoptimierung',
        'Innovative Technologielösungen',
      ]),
  },
  [GLOBAL_FIELD_NAMES.COMPANY_SECTOR]: {
    name: 'Tätigkeitssektor',
    instruction:
      'Geben Sie den Sektor an, in dem Ihr Unternehmen tätig ist, und wählen Sie in der Dropdown-Liste das passende Detaillierungsniveau.',
  },
  [GLOBAL_FIELD_NAMES.COMPANY_SUB_SECTOR]: {
    name: 'Tätigkeitsuntersektor',
    instruction:
      'Geben Sie den Untersektor an, in dem Ihr Unternehmen tätig ist, und wählen Sie in der Dropdown-Liste das passende Detaillierungsniveau.',
  },
  [GLOBAL_FIELD_NAMES.COMPANY_INDUSTRY_GROUP]: {
    name: 'Tätigkeits-Industriegruppe',
    instruction:
      'Geben Sie die Industriegruppe an, in der Ihr Unternehmen tätig ist, und wählen Sie in der Dropdown-Liste das passende Detaillierungsniveau.',
  },
  [GLOBAL_FIELD_NAMES.COMPANY_INDUSTRY]: {
    name: 'Tätigkeitsbranche',
    instruction:
      'Geben Sie die Branche an, in der Ihr Unternehmen tätig ist, und wählen Sie in der Dropdown-Liste das passende Detaillierungsniveau.',
    exampleOne: 'Herstellung von landwirtschaftlichen Maschinen und Geräten.',
    exampleTwo:
      'Übersetzungs- und Dolmetschdienstleistungen.\n Web-Suchportale und sonstige Informationsdienstleistungen.',
  },
  [GLOBAL_FIELD_NAMES.MAIN_GOALS]: {
    name: 'Hauptziele und -aufgaben',
    instruction:
      'Skizzieren Sie die strategischen Ziele des Unternehmens und betonen Sie kurz-, mittel- und langfristige Ziele, die mit Mission und Vision im Einklang stehen. Nennen Sie Fokusbereiche wie Marktexpansion, Umsatzwachstum oder Produktinnovation. Beschreiben Sie Strategien, Initiativen und KPIs, die die Zielerreichung vorantreiben.',
    exampleOne:
      'Langfristig: Erreichen einer globalen Marktführerschaft durch Diversifizierung des Produktportfolios, Investitionen in F&E für nachhaltige Agrartechnologien und Expansion in Schwellenmärkte. KPIs umfassen Marktanteil und Kundenzufriedenheit.',
    exampleTwo:
      'Kurzfristig: Verbesserung der Benutzerfreundlichkeit der Plattform durch neue Funktionen und Erhöhung der Nutzerbasis durch gezielte Marketingkampagnen. KPI: Nutzerengagement-Kennzahlen.',
  },
  [GLOBAL_FIELD_NAMES.STRATEGY_FOR_ACHIEVING_GOALS]: {
    name: 'Strategie für Projekterfolg',
    instruction:
      'Definieren Sie die Säulen der Erfolgsstrategie: Kundenorientierung, Innovation, operative Exzellenz. Beschreiben Sie Taktiken wie Marktdifferenzierung, Innovation, Effizienzsteigerung, Kundenbindung und Umgang mit Herausforderungen. Betonen Sie kontinuierliche Verbesserung und Anpassungsfähigkeit.',
    exampleOne:
      'Die Strategie des Unternehmens für den Projekterfolg basiert auf drei Schlüssel­säulen: Innovation, Marktdifferenzierung und Kundenorientierung. Das Unternehmen investiert kontinuierlich in Forschung und Entwicklung, um das Produktangebot zu verbessern und Markttrends voraus zu sein.',
    exampleTwo:
      'Die Unternehmensstrategie fokussiert auf Innovation, Kundenorientierung und Agilität. Durch kontinuierliche Produktverbesserung auf Basis von Marktfeedback, Priorisierung der Kundenzufriedenheit und schnelle Anpassung an Branchentrends strebt das Unternehmen nachhaltiges Wachstum und eine Führungsposition im Sprachdienstleistungssektor an.',
  },
  [GLOBAL_FIELD_NAMES.TARGET_MARKET]: {
    name: 'Zielmarkt und Konsum',
    instruction:
      'Geben Sie eine prägnante Marktübersicht: Bedürfnisse, Präferenzen und Problemstellungen der Kundschaft, die Sie adressieren. Heben Sie Besonderheiten wie geografische Schwerpunkte hervor. Schätzen Sie die Marktgröße und nennen Sie Quellen. Betonen Sie wirtschaftlichen Wert und Geschäftschancen.',
    exampleOne:
      'Der Zielmarkt des Unternehmens für Ketten­traktoren umfasst verschiedene landwirtschaftliche Betriebe, darunter kleinbäuerliche Familienbetriebe, mittelgroße Betriebe und große Agrarkonzerne in unterschiedlichen Regionen. Das jährliche Marktvolumen im Zielmarkt beträgt 100 Mio. USD.',
    exampleTwo:
      'Der Zielmarkt des Unternehmens umfasst Unternehmen und Privatpersonen mit Bedarf an globaler Kommunikation, darunter multinationale Konzerne, internationale Organisationen, Sprachdienstleister und Einzelpersonen, die Übersetzungsleistungen benötigen. Das jährliche Marktvolumen beträgt 49,6 Mrd. USD.',
  },
  [GLOBAL_FIELD_NAMES.TARGET_AUDIENCE]: {
    name: 'Zielgruppe',
    instruction:
      'Definieren Sie Ihre Zielgruppe hinsichtlich Demografie, Psychografie und Bedürfnissen. Betonen Sie die Passung von Produkt oder Dienstleistung. Heben Sie Besonderheiten wie Region, Branche oder typisches Verhalten hervor.',
    exampleOne:
      'Die Zielgruppe umfasst verschiedene Akteure im Agrarsektor, darunter Landwirte, landwirtschaftliche Genossenschaften, Agrarunternehmen und ländliche Betriebe. Diese Akteure bilden das Rückgrat der globalen Nahrungsmittelproduktion und decken Segmente wie Ackerbau, Sonderkulturen, Viehzucht und Gartenbau ab.',
    exampleTwo:
      'Die Zielgruppe umfasst Unternehmen, Organisationen und Privatpersonen mit vielfältigen Sprachbedürfnissen. Zu den Hauptkundengruppen zählen multinationale Konzerne, Regierungsbehörden, internationale NGOs, Sprachdienstleister, Bildungseinrichtungen sowie Privatpersonen, die Übersetzungen für persönliche oder berufliche Zwecke benötigen.',
  },
  [GLOBAL_FIELD_NAMES.TARGET_CHANNELS]: {
    name: 'Vertriebskanäle',
    instruction:
      'Geben Sie einen Überblick über die wichtigsten Vertriebskanäle: Direktvertrieb, Einzelhandel, E-Commerce usw. Erläutern Sie die Begründung der Kanalwahl unter Berücksichtigung von Reichweite, Kundenpräferenzen und Branchenstandards. Gehen Sie auf kanal­spezifische Vorteile und Herausforderungen ein.',
    exampleOne: ol([
      'Händler- und Distributoren-Netzwerk: Das Unternehmen arbeitet weltweit mit Händlern und Distributoren zusammen, um seine Ketten­traktoren zu vertreiben.',
      'Direktvertrieb: Das Unternehmen unterhält ein Direktvertriebsteam, das Kunden betreut, Produktinformationen bereitstellt und Verkaufsabschlüsse begleitet.',
    ]),
    exampleTwo:
      'Das Unternehmen vertreibt seine Dienstleistungen über verschiedene Kanäle, darunter die Online-Plattform, Direktvertriebsteams, Partnerschaften mit Sprachdienstleistern, Affiliate-Programme sowie die Teilnahme an Branchenveranstaltungen und Konferenzen. Zusätzlich nutzt das Unternehmen digitale Marketingstrategien wie Social Media und E-Mail-Kampagnen.',
  },
  [GLOBAL_FIELD_NAMES.MAIN_COMPETITORS]: {
    name: 'Hauptwettbewerber',
    instruction:
      'Analysieren Sie die Wettbewerbssituation: wichtigste Wettbewerber, Marktanteile, Angebote und Reichweite. Diskutieren Sie besondere Eigenschaften oder Vorteile.',
    exampleOne:
      'Die Hauptwettbewerber des Unternehmens im Markt für Agrarmaschinen sind globale Konzerne wie Unternehmen X und Unternehmen Y sowie regionale Anbieter wie Unternehmen Z. Sie bieten eine Palette von Traktoren und Landmaschinen mit modernen Funktionen und Technologien an, die direkt mit den Ketten­traktoren des Unternehmens hinsichtlich Leistung und Innovation konkurrieren.',
    exampleTwo:
      'Die Hauptwettbewerber des Unternehmens umfassen etablierte Sprachdienstleister wie [Wettbewerber A], [Wettbewerber B] und [Wettbewerber C] sowie neue Akteure im Bereich Sprachtechnologie wie [Wettbewerber D] und [Wettbewerber E]. Diese Unternehmen bieten ähnliche Übersetzungsdienstleistungen und KI-gestützte Lösungen für globale Kommunikationsbedürfnisse an.',
  },
  [GLOBAL_FIELD_NAMES.PROJECTED_ANNUAL_INCOME]: {
    name: 'Prognostiziertes Jahreseinkommen',
    instruction:
      'Berechnen Sie das prognostizierte durchschnittliche Jahreseinkommen, indem Sie die erwarteten Jahreseinkommen der nächsten drei Jahre addieren und durch drei teilen. Verwenden Sie die Formel:\n\nDurchschnittliches prognostiziertes Jahreseinkommen =\n(Einkommen Jahr 1 + Einkommen Jahr 2 + Einkommen Jahr 3) / 3\n\nGeben Sie das prognostizierte Einkommen für jedes Jahr an und begründen Sie Ihre Annahmen anhand von Marktentwicklungen, Umsatzprognosen und anderen relevanten Faktoren.',
    exampleOne: '',
    exampleTwo: '',
  },
  [GLOBAL_FIELD_NAMES.FORECASTED_PROFITABILITY]: {
    name: 'Prognostizierte Rentabilität',
    instruction:
      'So berechnen Sie die prognostizierte Rentabilität in Prozent:' +
      ol([
        'Schätzen Sie den zukünftigen Nettogewinn.',
        'Prognostizieren Sie den Gesamtumsatz.',
        'Teilen Sie den Nettogewinn durch den Gesamtumsatz.',
        'Multiplizieren Sie das Ergebnis mit 100, um den Wert in Prozent zu erhalten.',
      ]) +
      'Verwenden Sie die Formel: (Nettogewinn / Gesamtumsatz) * 100 = Prognostizierte Rentabilität (%).',
    exampleOne: '',
    exampleTwo: '',
  },
  [GLOBAL_FIELD_NAMES.PROJECT_PAYBACK_PERIOD]: {
    name: 'Prognostizierte Amortisationsdauer',
    instruction:
      'So berechnen Sie die prognostizierte Amortisationsdauer auf Basis des Gewinns:' +
      ol([
        'Ermitteln Sie die gesamte Anfangsinvestition.',
        'Prognostizieren Sie den jährlichen Nettogewinn.',
        'Teilen Sie die gesamte Anfangsinvestition durch den jährlichen Nettogewinn.',
        'Wandeln Sie das Ergebnis in Monate um, indem Sie mit 12 multiplizieren.',
      ]) +
      'Verwenden Sie die Formel: Amortisationsdauer =\n(Gesamte Anfangsinvestition / jährlicher Nettogewinn) * 12',
    exampleOne: '',
    exampleTwo: '',
  },
  [GLOBAL_FIELD_NAMES.TOTAL_COST]: {
    name: 'Gesamtkosten des Projekts',
    instruction:
      'Führen Sie eine sorgfältige Bewertung der prognostizierten Ausgaben durch. Die umfassende Budgetanalyse sollte verschiedene Bereiche abdecken, darunter Betriebskosten, Investitionsausgaben, Marketingmaßnahmen, Technologieinvestitionen und Personalaufwand.',
    exampleOne: '',
    exampleTwo: '',
  },
  [GLOBAL_FIELD_NAMES.FUNDING_AMOUNT]: {
    name: 'Finanzierungsbedarf',
    instruction:
      'Bestimmen Sie den benötigten Finanzierungsbetrag, indem Sie eine umfassende Bewertung aller Projektaufwendungen und erwarteten Kosten vornehmen.',
    exampleOne: '',
    exampleTwo: '',
  },
  [GLOBAL_FIELD_NAMES.PERCENTAGE_OF_FUNDING]: {
    name: 'Finanzierung aus Eigenmitteln',
    instruction: 'Geben Sie den Prozentsatz der Projektkosten an, der aus eigenen Mitteln finanziert werden soll.',
    exampleOne: '',
    exampleTwo: '',
  },
  [GLOBAL_FIELD_NAMES.MISSION]: {
    name: 'Unternehmensmission',
    instruction:
      'Definieren Sie die Mission des Unternehmens und formulieren Sie Zweck und Werte. Heben Sie den Beitrag am Markt oder in der Gesellschaft hervor und betonen Sie Ihr einzigartiges Leistungsversprechen. Richten Sie die Mission an übergeordneten Zielen aus und zeigen Sie Ihr Bekenntnis zu Prinzipien wie Innovation, Kundenservice oder Nachhaltigkeit.',
    exampleOne:
      'Die Mission des Unternehmens ist es, fortschrittliche Traktorlösungen zu entwickeln, die auf Nachhaltigkeit und technologische Innovation ausgerichtet sind und der globalen Agrargemeinschaft dienen.',
    exampleTwo:
      'Die Mission des Unternehmens ist es, Sprachbarrieren abzubauen und globale Verbindungen zu fördern, indem nahtlose, hochwertige Übersetzungsdienstleistungen durch innovative Technologie und exzellenten Kundenservice bereitgestellt werden.',
  },
  [GLOBAL_FIELD_NAMES.COMPANY_STRENGTHS]: COMPANY_STRENGTHS_INSTRUCTIONS,
  [GLOBAL_FIELD_NAMES.COMPANY_WEAKNESSES]: COMPANY_WEAKNESSES_INSTRUCTIONS,
  [GLOBAL_FIELD_NAMES.COMPETITIVE_ADVANTAGE]: {
    name: 'Einzigartige Merkmale oder Wettbewerbsvorteile',
    instruction:
      'Beginnen Sie mit einem Aufhänger oder einer fesselnden Aussage, um die Aufmerksamkeit der Leser zu gewinnen. Benennen Sie klar den Hauptzweck oder die primäre Funktion des Produkts. Heben Sie ein bis zwei zentrale Merkmale hervor, die es von anderen Angeboten am Markt unterscheiden.',
    exampleOne:
      'Die Ketten­traktoren zeichnen sich durch ihr innovatives Endlosketten-Design aus, das sie von herkömmlichen Radtraktoren abhebt. Dieses Design bietet eine unvergleichliche Traktion und Auftrieb, besonders vorteilhaft für schwere oder nasse Böden. Darüber hinaus minimiert die patentierte Gummibeschichtung der Ketten den Bodendruck und die Bodenverdichtung, wodurch Ernteschäden reduziert werden.',
    exampleTwo: ol([
      'Proprietäre Technologie: Die Plattform nutzt hochmoderne, eigens entwickelte KI-Technologie und verschafft so Wettbewerbsvorteile in Effizienz, Genauigkeit und Innovation.',
      'Umfassende Sprachabdeckung: Mit über 100 Sprachen decken die Dienstleistungen ein breites Spektrum sprachlicher Bedürfnisse ab und bieten Kunden einen einzigartigen Zugang zu globalen Kommunikationskanälen.',
    ]),
  },
  [GLOBAL_FIELD_NAMES.PRODUCT_DEVELOPMENT_PLANS]: {
    name: 'Pläne für Produkt-/Dienstleistungsentwicklung',
    instruction:
      'Formulieren Sie die strategische Vision Ihres Unternehmens für Produktentwicklung und Expansion und beschreiben Sie zukünftige Forschungsinitiativen sowie potenzielle neue Produktkategorien oder -segmente.',
    exampleOne:
      'Die Pläne für die Entwicklung neuer Produkte umfassen Folgendes:' +
      ol([
        'Anbaugeräte und Anbaukomponenten: Das Unternehmen entwickelt eine Reihe fortschrittlicher Anbaugeräte und Aufsätze, die mit Ketten­traktoren eingesetzt werden können, um Vielseitigkeit und Produktivität bei Aufgaben wie Aussaat, Bodenbearbeitung und Ernte zu erhöhen.',
      ]),
    exampleTwo:
      'Potenzielle Bereiche, in denen die Sprachdienstleistungs-Plattform die Entwicklung neuer oder verwandter Produkte prüft:' +
      ol([
        'Multimodale Übersetzungsdienste: Entwicklung von Services, die Übersetzungen über mehrere Modalitäten – Text, Sprache, Bilder und Video – unterstützen, um umfassendere Sprachlösungen anzubieten.',
      ]),
  },
  [GLOBAL_FIELD_NAMES.LOAN_BORROW_AMOUNT]: {
    name: 'Geplante Darlehenssumme',
    instruction:
      'Beschreiben Sie die geplante Darlehenshöhe und die Begründung dafür. Begründen Sie den Finanzierungsbedarf mit Kosten­effizienz, Hebelwirkung von Chancen und dem Ziel, finanzielle Flexibilität für Wachstum und Stabilität zu bewahren.',
    exampleOne: '',
    exampleTwo: '',
  },
  [GLOBAL_FIELD_NAMES.INVESTMENT_AMOUNT]: {
    name: 'Aufgebrachte Investitionssumme',
    instruction:
      'Geben Sie die Höhe der eingeworbenen Investitionen und die Begründung an. Erläutern Sie den Investitionsbedarf anhand von Wachstumschancen, Marktnachfrage und strategischen Zielen mit dem Ziel, Unternehmenswert und Wettbewerbsfähigkeit zu steigern.',
    exampleOne: '',
    exampleTwo: '',
  },
  [GLOBAL_FIELD_NAMES.REVENUE_STREAMS]: {
    name: 'Geschäftsmodell',
    instruction:
      'Skizzieren Sie die primären Einnahmequellen, z. B. Produktverkäufe, Abonnements oder Dienstleistungen. Fassen Sie wesentliche finanzielle Annahmen zusammen, einschließlich Preisgestaltung, Wachstumsraten und Marktnachfrage. Listen Sie die wichtigsten Partner auf und heben Sie deren Rolle bei der Unterstützung des Geschäftsbetriebs und des Wachstums hervor.',
    exampleOne:
      'Unsere primären Einnahmequellen umfassen den direkten Verkauf von Produktlinien, abonnementsbasierte Dienstleistungen sowie strategische Partnerschaften für Co-Branding-Angebote. Das Umsatzwachstum wird auf Basis von Markttrends prognostiziert, wobei von einem stetigen Anstieg der Kundengewinnung ausgegangen wird. Die Kostenannahmen beinhalten stabile Produktionskosten sowie schrittweise steigende Marketingaufwendungen. Zu unseren wichtigsten Partnern zählen Rohstofflieferanten, Distributoren zur Markterschließung sowie Technologieanbieter zur Plattformunterstützung. Die Zusammenarbeit mit diesen Partnern stärkt unsere Wertschöpfungskette und erweitert unsere Marktpräsenz.',
    exampleTwo:
      'Unsere zentralen Einnahmequellen bestehen aus Produktverkäufen über E-Commerce-Plattformen, Lizenzgebühren für firmeneigene Software sowie beratenden Dienstleistungen, die auf individuelle Kundenbedürfnisse zugeschnitten sind. Die Umsatzprognosen basieren auf der Elastizität der Marktnachfrage, mit konservativen Annahmen unter Berücksichtigung saisonaler Schwankungen. Die Kostenannahmen legen den Fokus auf operative Effizienz und Skalierbarkeit und gehen von einem kontrollierten Kostenwachstum aus. Strategische Allianzen mit Herstellern sichern eine stabile Lieferkette, während digitale Marketingagenturen die Markenbekanntheit steigern.',
  },
  [GLOBAL_FIELD_NAMES.MARKETING_STRATEGY]: {
    name: 'Vertriebsstrategie',
    instruction:
      'Beschreiben Sie die wichtigsten Methoden zur Gewinnung und Bindung von Kunden, z. B. Werbekanäle, Preisstrategien und Verkaufsförderungsmaßnahmen. Ergänzen Sie dies um Ihren Vertriebsansatz, einschließlich Vertriebskanälen, Zielmärkten und Umsatzzielen.',
    exampleOne: ol([
      ' Händler- und Distributornetzwerk: Das Unternehmen arbeitet mit Händlern und Distributoren weltweit zusammen, um seine Kettenfahrzeuge zu vertreiben.',
      'Direktvertrieb: Das Unternehmen unterhält ein eigenes Vertriebsteam, das für die Kundenansprache, Produktberatung und Abwicklung von Verkaufsabschlüssen verantwortlich ist.',
    ]),
    exampleTwo:
      'Das Unternehmen vertreibt seine Dienstleistungen über verschiedene Kanäle, darunter die Online-Plattform, direkte Vertriebsteams, Partnerschaften mit Sprachdienstleistern, Affiliate-Programme sowie die Teilnahme an Branchenveranstaltungen und Konferenzen. Darüber hinaus setzt das Unternehmen digitale Marketingstrategien wie Social-Media-Aktivitäten und E-Mail-Kampagnen ein.',
  },
};
